import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class TimesheetService {
    static getTimesheet(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.get(`timesheet?filter=${qs}`));
    }
    static GetTimesheetDaySummary(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.get(`timesheet-day-summary?filter=${qs}`));
    }
}
